import { FieldValueLookupError } from '@atlassian/ui-modifications-core/utils';
import type {
	ComponentsPublicSetValue,
	ComponentsPublicGetValues,
} from '@atlassian/jira-ui-modifications-common/src/common/utils/common/fields/components.tsx';
import { getValueLookupValuesDiff } from '@atlassian/jira-ui-modifications-common/src/common/utils/common/utils/get-value-lookup-values-diff/index.tsx';
import { isNotEmptyString } from '@atlassian/ui-modifications-public-api-utils/is-not-empty-string';
import { multiValueLookup } from '@atlassian/jira-ui-modifications-common/src/common/utils/common/utils/multi-value-lookup/index.tsx';

type LookupValue = {
	id: string;
	name: string;
};

type ComponentsInternalValue = {
	value: string;
	label: string;
}[];

type ComponentsLookupValues = LookupValue[];

export const validateComponentsSetValue = (value: unknown): value is ComponentsPublicSetValue =>
	Array.isArray(value) && value.every(isNotEmptyString);

export const componentsGetValueTransformer = (
	internalValue: ComponentsInternalValue,
): ComponentsPublicGetValues => {
	if (!internalValue) {
		return [];
	}

	return internalValue.map(({ value: id, label: name }) => ({
		id,
		name,
	}));
};

export const componentsSetValueTransformer = (
	publicValue: ComponentsPublicSetValue,
	lookupValues?: ComponentsLookupValues,
): ComponentsInternalValue => {
	if (!publicValue.length) {
		return [];
	}

	const filteredLookupValues = multiValueLookup<LookupValue>(publicValue, lookupValues, 'id');

	if (publicValue.length !== filteredLookupValues.length) {
		const notFoundValues = getValueLookupValuesDiff(publicValue, lookupValues, 'id');

		throw new FieldValueLookupError(notFoundValues.join());
	}

	return filteredLookupValues.map(({ id: value, name: label }) => ({
		value,
		label,
	}));
};
